export default __webpack_public_path__ + "static/unicorn-72f5eb51a5f95b52dbac7dfcb23ad126.png";